var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJycx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 18,
    height: 18,
    style: {
      borderColor: "rgba(0,0,0,0)",
      borderWidth: "bpx",
      borderStyle: "undefined"
    },
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.164 6.013c2.333-2.077 5.426-3.347 8.815-3.347 0.007 0 0.015 0 0.022 0h-0.001c7.364 0 13.333 5.969 13.333 13.333 0 0.006 0 0.014 0 0.021 0 2.845-0.895 5.48-2.419 7.641l0.028-0.042-3.609-7.62h3.333c0-0 0-0 0-0 0-5.891-4.776-10.667-10.667-10.667-2.992 0-5.696 1.232-7.633 3.215l-0.002 0.002-1.2-2.536zM24.836 25.987c-2.333 2.077-5.426 3.347-8.815 3.347-0.007 0-0.015 0-0.022-0h0.001c-7.364 0-13.333-5.969-13.333-13.333 0-2.833 0.884-5.46 2.391-7.62l3.609 7.62h-3.333c0 0 0 0 0 0 0 5.891 4.776 10.667 10.667 10.667 2.992 0 5.696-1.232 7.633-3.215l0.002-0.002 1.2 2.536zM17.333 18.047h4v2.667h-4v2.667h-2.667v-2.667h-4v-2.667h4v-1.333h-4v-2.667h3.448l-2.829-2.828 1.888-1.885 2.827 2.828 2.828-2.828 1.887 1.885-2.829 2.829h3.448v2.667h-4v1.333z",
    fill: "rgba(255,255,255,1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJycx);
export default __webpack_public_path__ + "static/media/jycx.a704a2d0.svg";
export { ForwardRef as ReactComponent };